module.exports = {"1":"English","2":"German","3":"French","4":"Japanese","5":"Danish","6":"Spanish","7":"Italian","8":"Dutch","9":"Norwegian","10":"Portuguese","11":"Finnish","12":"Swedish","13":"Czech","14":"Hungarian","15":"Polish","16":"Romanian","17":"Croatian","18":"Slovak","19":"Slovene","20":"Greek","21":"Bulgarian","22":"Russian","23":"Turkish","24":"Estonian","25":"Latvian","26":"Lithuania","27":"Brazilian","28":"Traditional Chinese","29":"Korean","30":"Simplified Chinese","31":"Arabic","32":"Thai"}


//////////////////
// WEBPACK FOOTER
// ./resources/js/lang/en/languages.json
// module id = Mktx
// module chunks = 22